// custom.vmodel.mixin.js
/*import Vue from "vue";*/

export default {
  data() {
    return {
      isLoaderActive: false
    };
  },
  methods: {
    showLoading(timeout) {
      this.isLoaderActive = true;

      if (timeout != undefined) {
        setTimeout(() => {
          this.isLoaderActive = false;
        }, timeout);
      }
    },
    hideLoading(timeout) {
      if (timeout != undefined) {
        setTimeout(() => {
          this.isLoaderActive = false;
        }, timeout);
      } else {
        this.isLoaderActive = false;
      }
    }
  }
};
